import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

/*
  SmartAdmin button with custom styles for actions in forms, dialogs, etc.
  < Button
    disabled - bool to specify if button should be disabled
    variant="primary/secondary/etc" or
            "outline-primary/outline-secondary/etc" - styling class for the button
    type="button/submit" - defines button type attribute
  >
  {children}
  </Button>

  onClick/onBlur/etc events are part of {..props} and don't need to be included as individual props
  If styling attributes are not included, the button type is set to 'button' with "primary" styling
  Spacing of mr-1 (margin right 1px) set for better visual appeal

  Optional: Additional styling rules can be added to variant
            ie. variant="primary btn-block" to set 100% width button
*/
const CustomButton = ({
  bareButton,
  children,
  disabled,
  type = 'button',
  variant = 'primary',
  className = '',
  tooltipText = null,
  tooltipPlacement = 'top',
  tooltipTrigger = ['hover', 'focus'],
  onClick = () => null,
  ...rest
}) => {
  const button = (
    <Button
      className={bareButton ? className : `btn btn-${variant} waves-effect mr-1 ${className}`}
      type={type === 'submit' ? 'submit' : 'button'}
      disabled={disabled}
      onClick={onClick}
      {...rest}
    >
      {children}
    </Button>
  );

  return (
    tooltipText
      ? (
        <OverlayTrigger
          placement={tooltipPlacement}
          trigger={tooltipTrigger}
          overlay={<Tooltip id="tooltip-custom-button" style={{ margin: 0 }}>{tooltipText}</Tooltip>}
        >
          {button}
        </OverlayTrigger>
      )
      : button
  );
};

CustomButton.propTypes = {
  bareButton: PropTypes.bool,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit']),
  className: PropTypes.string,
  variant: PropTypes.string,
  tooltipText: PropTypes.string,
  tooltipPlacement: PropTypes.string,
  tooltipTrigger: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  onClick: PropTypes.func,
};

export default CustomButton;
